import { Button } from '@/common/ui/button'
import { Card, CardContent, CardHeader } from '@/common/ui/card'
import { Plus } from 'lucide-react'
import { useNavigate } from 'react-router-dom'
import Heading from '@/common/shared/heading'
import BrokeFlexMessageTable from '../BrokeFlexMessageTable'
import type { BrokeFlexMessageCampaignModel } from '../../types'

interface BrokeFlexMessageListingProps {
	data: BrokeFlexMessageCampaignModel[]
	isLoading: boolean
}

export default function BrokeFlexMessageListing({
	data,
	isLoading,
}: BrokeFlexMessageListingProps) {
	const navigate = useNavigate()

	return (
		<div className="space-y-4 px-4 sm:px-0">
			<div className="flex flex-col gap-4 sm:flex-row sm:items-start sm:justify-between">
				<Heading
					title="จัดการแคมเปญข้อความแจ้งเตือนเงินหมด"
					description="รายการแคมเปญแจ้งเตือนเมื่อสมาชิกมีเงินหมด"
				/>
				<Button
					onClick={() =>
						navigate('/operator/messaging/broke-flex-message/create')
					}
				>
					<Plus className="mr-2 h-4 w-4" />
					สร้างแคมเปญใหม่
				</Button>
			</div>

			<Card>
				<CardHeader />
				<CardContent>
					<BrokeFlexMessageTable data={data} isLoading={isLoading} />
				</CardContent>
			</Card>
		</div>
	)
}
